import React, { useEffect } from 'react'
import { useInView } from 'react-intersection-observer'
import { motion, useAnimation } from 'framer-motion'

const AnimationWrapper = ({ children, type, delay }) => {
    const [ref, inView] = useInView();
    const controls = useAnimation();
    useEffect(() => {
        if (inView) {
            controls.start('show')
        }
    }, [controls, inView]);
    let variants = {}
    switch (type) {
    case 'fade-up':
        variants = {
            show: {
                opacity: 1,
                y: 0,
                transition: {
                    ease: 'easeOut',
                    duration: .6,
                    delay: delay ? delay : 0,
                },
            },
            hidden: { opacity: 0, y: 30 },
        }
        break;
    case 'fade-left':
        variants = {
            show: {
                opacity: 1,
                x: 0,
                transition: {
                    ease: 'easeOut',
                    duration: .6,
                    delay: delay ? delay : 0,
                },
            },
            hidden: { opacity: 0, x: -30 },
        }
        break;

    case 'bounce-vertical':
        const bounceTransition = {
            y: {
                duration: 0.6,
                yoyo: Infinity,
                type: 'spring',
                stiffness: 100,
                mass: 0.5,
                restSpeed: 0.5,
            },
        }
        variants = {
            show: {
                opacity: 1,
                y: ['50%', '-50%'],
                transition: bounceTransition,
            },
            hidden: { opacity: 1 },
        }
        break;
    default:
        // Disabled
        variants = {
            show: { opacity: 1 },
            hidden: { opacity: 1 },
        }
        break;
    }
    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial='hidden'
            variants={variants}
        >
            {children}
        </motion.div>
    )
}

export default AnimationWrapper
